/*
     __  __            _        _         _
    |  \/  | __ _ _ __| | _____| |_ _ __ | | __ _  ___ ___
    | |\/| |/ _` | '__| |/ / _ \ __| '_ \| |/ _` |/ __/ _ \
    | |  | | (_| | |  |   <  __/ |_| |_) | | (_| | (_|  __/
    |_|  |_|\__,_|_|  |_|\_\___|\__| .__/|_|\__,_|\___\___|
                                   |_|

 */

import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";
import { sendFacebookPixelEvent } from "../modules/analytics/facebook-pixel.js";

function initPageSpecificAnalytics() {
  // Event gets dispatched from the my-account react app
  document.addEventListener("account-created", () => {
    sendFacebookPixelEvent("CompleteRegistration", {
      content_name: "account",
      status: true,
    });
  });
}

async function initAccountPage() {
  await initTranslation();
  initPage();
  initPageSpecificAnalytics();
}

initAccountPage();
